module.exports = __webpack_public_path__ + "static/media/background_btn_submit_2.ef22845c.png";